module.exports = __webpack_public_path__ + "static/iso-c371ca3591c5e01337fbc597660d14b6.jpg";